import * as WhatTimeIsItService from '../../services/whatTimeIsIt/WhatTimeIsItService';
import AdyenService from '../../services/adyen/AdyenService';

export function execute(payment) {
  return new Promise((resolve, reject) => {
    WhatTimeIsItService.get()
      .then(isoDate => {
        AdyenService.create(payment, isoDate.currentTimestamp)
          .then(cardInformation => {
            resolve({
              cardEncrypted: cardInformation
            });
          })
          .catch(error => {
            reject(error);
          });
      })
      .catch(error => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/usecases/cryptoAdyen/CryptoAdyenUC.js